module.exports = __webpack_public_path__ + "static/media/bgimg.45eed2f1.jpg";